/**
 * Za paginirane prikaze obaveštenja (header dropdown, admin carousel) —
 * hookovi za kontekst treba da dobiju samo trenutno vidljivo obaveštenje.
 *
 * @param {object[]} notifications - Puna lista obaveštenja.
 * @param {number} pageIndex - Indeks trenutne stranice (0-based).
 * @returns {object[]} Niz sa jednim elementom ili prazan niz.
 */
export function notificationsAtPage(notifications, pageIndex) {
  const item = notifications?.[pageIndex];
  return item ? [item] : [];
}
